<div class="secundary-header desktop">
  <div class="display-flex justify-between">
    <div>
      <div class="name-info display-flex">
        @for (item of selectedPriorities; track $index) {
          <div>
            @if (item.idPriority !== this.overEightyYearsEnum && item.idPriority !== this.overSixtyYearsEnum && item.idPriority !== this.autismEnum && item.idPriority !== prioritiesStatusEnum.lactante) {
              <mat-icon class="priority-icon"
              >{{item.icon}}</mat-icon>
            }
            @if (item.idPriority === this.autismEnum) {
              <img src="assets/images/autism-symbol.png" class="img-adjust"
                />
            }
            @if (item.idPriority === this.overEightyYearsEnum || item.idPriority === this.overSixtyYearsEnum) {
              <span class="priority-age"
              >{{item.icon}}</span>
            }
            @if (item.idPriority === prioritiesStatusEnum.lactante) {
              <span class="priority-icon material-symbols-outlined">{{item.icon}}</span>
            }
          </div>
        }
        @if (episodeData.name) {
          <div>
            <div class="name" matTooltip="Ver dados do paciente" #tooltip="matTooltip"
              (click)="openModalPatientDetails()">
              <mat-icon class="name-icon" aria-hidden="false" aria-label="Detalhes">assignment_ind</mat-icon>
              <span>
                <span class="name-title">{{episodeData.isUnidentifiedPatient ? episodeData.name + ' - NÃO
                IDENTIFICADO': episodeData.name}}</span>
                @if (episodeData.isSchedule) {
                  <span> - <strong>Agendado para:</strong>
                  {{episodeData.dateStartSchedule | date: 'dd/MM/yyyy HH:mm'}}
                </span>
              }
              @if (episodeData.medicalSpecialityName != null) {
                <span> -
                  {{episodeData.medicalSpecialityName}}
                </span>
              }
            </span>
          </div>
          <a #tooltipLink (click)="tooltip.toggle()"></a>
          @if (episodeData.socialName) {
            <div class="social-name">
              <span><span>{{episodeData.name}}</span>
              @if (episodeData.isSchedule) {
                <span> - <strong>Agendado para:</strong>
              {{episodeData.dateStartSchedule | date: 'dd/MM/yyyy HH:mm'}}</span>
            }
            @if (episodeData.medicalSpecialityName != null) {
              <span> -
              {{episodeData.medicalSpecialityName}}</span>
            }
          </span>
        </div>
      }
    </div>
  }
  @if (episodeData.listAllergyStruct && episodeData.listAllergyStruct.length > 0) {
    <div
      (click)="openAllergies()">
      <button class="allergy">Alérgico</button>
    </div>
  }
  <div class="status-caller"
    [ngStyle]="{'background-color': gravityColorCode || episodeData.gravityColorCode}">
    <span class="text-bold">{{gravity || episodeData.gravity ? gravity || episodeData.gravity :
    '-'}}</span>
  </div>
  @if (!episodeData.name) {
    <div>
      <div class="name-not-found">
        <span>Nenhum paciente chamado</span>
      </div>
    </div>
  }
</div>
<div class="display-flex">
  <div class="info-content">
    <div>
      <span class="text-bold">Senha:</span>
      <span class="padding-left-1">{{episodeData.token ? episodeData.token : '-'}}</span>
    </div>
    <div>
      <span class="text-bold">Episódio:</span>
      <span class="padding-left-1">{{episodeData.idEpisode ? episodeData.idEpisode : '-'}}</span>
    </div>
    <div>
      <span class="text-bold">Espera:</span>
      <span class="padding-left-1">{{episodeData.waitingTime ? (episodeData.waitingTime) :
      '-'}} </span>
    </div>
    <div>
      <span class="text-bold">Nasc.:</span>
      <span class="padding-left-1">{{episodeData.birthDate ? formatedBirth : '-'}}</span>
    </div>
    <div>
      <span class="text-bold">Idade:</span>
      <span class="padding-left-1">{{episodeData.age ? episodeData.age : '-'}}</span>
    </div>
    <div>
      <span class="text-bold">Retorno:</span>
      <span class="padding-left-1">{{episodeData.regress ? formatedRegress : '-'}}</span>
    </div>
    <div>
      <span class="text-bold">Linha de cuidado:</span>
      <span class="padding-left-1">{{episodeData.patientCareLinePriorityStruct ?
        episodeData.patientCareLinePriorityStruct.careLinePriorityName ?
        (episodeData.patientCareLinePriorityStruct.careLinePriorityName + ' - ' +
      episodeData.patientCareLinePriorityStruct.careLinePriorityStatusName ): '-' : '-'}} </span>
    </div>
    <div>
      <span class="text-bold">Suspeita:</span>
      @if (!isSuspicionEvaluated && !episodeData.suspicionName) {
        <span class="padding-left-1"> -
        </span>
      }
      @if ((isSuspicionEvaluated != true && isSuspicionEvaluated != false ) && episodeData.suspicionName) {
        <span
        class="padding-left-1">{{episodeData.suspicionName + ' - aguardando validação'}}</span>
      }
      @if ((isSuspicionEvaluated == true || isSuspicionEvaluated == false ) && episodeData.suspicionName) {
        <span
          class="padding-left-1">{{episodeData.suspicionName + ' - ' +
        episodeData.suspicionStatusName}} </span>
      }
    </div>
  </div>
</div>
</div>
<div class="glasgow-and-pain" col-md-6>
  <div class="row">
    <a mat-flat-button (click)="clickVital('gla')" matTooltip="Visualizar Histórico" class="list-header">
      <div class="glasgow-content">
        <span class="text-bold">Glasgow</span>
        <span>{{ discriminators && discriminators[discriminatorTypeEnum.Glasgow] ?
          discriminators[discriminatorTypeEnum.Glasgow] : (episodeData.glasgow ?
          episodeData.glasgow : '-') }}
        </span>
      </div>
    </a>
  </div>
  <div class="row">
    <a mat-flat-button (click)="clickVital('p')" matTooltip="Visualizar Histórico" class="list-header">
      <div class="pain-content"
        [ngStyle]="{'background-color': painColorCode[0] || episodeData.painColorCode}">
        <span class="text-bold">Dor</span>
        <span>{{ discriminators && discriminators[discriminatorTypeEnum.Dor] != null ?
          discriminators[discriminatorTypeEnum.Dor] : (discriminators &&
          discriminators[discriminatorTypeEnum.DorCoceira] != null ?
          discriminators[discriminatorTypeEnum.DorCoceira] : (pain != null && pain != ''?
          pain : (episodeData.pain != null && episodeData.pain != ''?
          episodeData.pain : '-' )))}}
        </span>
      </div>
    </a>
  </div>
</div>
<div class="status-content display-flex">
  <a mat-flat-button (click)="clickVital('s')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Saturação</span>
      @if (hasVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
  <a mat-flat-button (click)="clickVital('g')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Glicemia</span>
      @if (hasVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
  <a mat-flat-button (click)="clickVital('b')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Pressão</span>
      @if (hasVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
  <a mat-flat-button (click)="clickVital('t')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Temperatura</span>
      @if (hasVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
  <a mat-flat-button (click)="clickVital('h')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Pulso</span>
      @if (hasVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
  <a mat-flat-button (click)="clickVital('f')" matTooltip="Visualizar Histórico" class="list-header">
    <div class="status-content__info">
      <span class="text-bold">Freq. respiratória</span>
      @if (hasVitalValue(discriminatorTypeEnum.FrequenciaRespiratoria, 'respiratoryFrequency', 'respiratoryFrequencyComplementaryData')) {
        <span>
          {{ getVitalValue(discriminatorTypeEnum.FrequenciaRespiratoria, 'respiratoryFrequency', 'respiratoryFrequencyComplementaryData') }}
        </span>
      }
      @if (!hasVitalValue(discriminatorTypeEnum.FrequenciaRespiratoria, 'respiratoryFrequency', 'respiratoryFrequencyComplementaryData')) {
        <mat-icon style="align-self: anchor-center;">cached</mat-icon>
      }
    </div>
  </a>
</div>
<div class="status-content__info score-deterioration-and-restart">
  @if (episodeData.monitoringDataToDeteriorationProtocol) {
    <div class="score-deterioration">
      <span class="text-bold">Score News</span>
      <a mat-flat-button matTooltip="Score News" (click)="openModalWithDeteriorationProtocolScore()" type="button" color="accent" class="btn-block"
        [style.background-color]="episodeData.monitoringDataToDeteriorationProtocol.scoreRangeColorCode">
        <div class="status-content__info score-deterioration-value">
          <span>
            {{ this.episodeData.monitoringDataToDeteriorationProtocol?.totalScore}}
          </span>
        </div>
      </a>
    </div>
  }
  @if (isClassification) {
    <div>
      <a mat-flat-button matTooltip="Reiniciar medidores" (click)="emitMeasurerRestart()" type="button"
        color="accent" class="btn-block">
        <mat-icon class="reload-icon">sync</mat-icon>
      </a>
    </div>
  }

</div>

</div>
</div>
@if (isLoading) {
  <mat-progress-bar class="desktop" mode="indeterminate"></mat-progress-bar>
}

<cdk-accordion class="accordion mobile">
  <cdk-accordion-item #accordionItem="cdkAccordionItem" class="accordion-item" role="button" tabindex="0"
    [attr.id]="'accordion-header'" [attr.aria-expanded]="accordionItem.expanded"
    [attr.aria-controls]="'accordion-body'">
    <div [ngClass]="{'accordion-item-header-expanded': accordionItem.expanded}" class="accordion-item-header"
      (click)="accordionItem.toggle()">
      <div class="name-info display-flex">
        @if (selectedPriorities) {
          <div>
            @for (item of selectedPriorities; track $index) {
              <mat-icon class="priority-icon">{{item.icon}}</mat-icon>
            }
          </div>
        }
        @if (episodeData.name) {
          <div>
            <div class="name truncate">
              <button mat-flat-button matTooltip="Dados do paciente" type="button" color="secundary"
                class="btn-details" (click)="openModalPatientDetails()">
                @if (isLoading == false) {
                  <mat-icon aria-hidden="false"
                  aria-label="Detalhes">assignment_ind</mat-icon>
                }
              </button>
              <span>{{episodeData.name}}</span>
            </div>
            @if (episodeData.socialName) {
              <div class="social-name truncate">
                <span>{{episodeData.socialName}}</span>
              </div>
            }
            @if (episodeData.listAllergyStruct && episodeData.listAllergyStruct.length > 0) {
              <div
                (click)="openAllergies()">
                <button class="allergy">Alérgico</button>
              </div>
            }
          </div>
        }
        @if (!episodeData.name) {
          <div>
            <div class="name-not-found">
              <span>Nenhum paciente chamado</span>
            </div>
          </div>
        }
      </div>
      @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    <div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
      [attr.id]="'accordion-body'" [attr.aria-labelledby]="'accordion-header'">
      <div class="info-content">
        <div class="line-height">
          <span class="text-bold">Senha:</span>
          <span class="padding-left-1">{{episodeData.token ? episodeData.token : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Episódio:</span>
          <span class="padding-left-1">{{episodeData.idEpisode ? episodeData.idEpisode : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Espera:</span>
          <span class="padding-left-1">{{episodeData.waitingTime ? episodeData.waitingTime : '-'}} min</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Linha de cuidado:</span>
          <span class="padding-left-1">{{careLinePriority ? careLinePriority : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Suspeita:</span>
          @if (!isSuspicionEvaluated && !episodeData.suspicionName) {
            <span class="padding-left-1"> - </span>
          }
          @if ((isSuspicionEvaluated != true && isSuspicionEvaluated != false ) && episodeData.suspicionName) {
            <span
            class="padding-left-1">{{episodeData.suspicionName + ' - aguardando validação'}}</span>
          }
          @if ((isSuspicionEvaluated == true || isSuspicionEvaluated == false ) && episodeData.suspicionName) {
            <span
              class="padding-left-1">{{episodeData.suspicionName + ' - ' + episodeData.suspicionStatusName}}
            </span>
          }
        </div>
        <div class="line-height">
          <span class="text-bold">Nasc.:</span>
          <span class="padding-left-1">{{episodeData.birthDate ? formatedBirth : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Idade:</span>
          <span class="padding-left-1">{{episodeData.age ? episodeData.age : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Retorno:</span>
          <span class="padding-left-1">{{episodeData.regress ? formatedRegress : '-'}}</span>
        </div>
        <div class="status-caller line-height" [ngStyle]="{'background-color': episodeData.gravityColorCode}">
          <span class="text-bold">{{episodeData.gravity ? episodeData.gravity : '-'}}</span>
        </div>
      </div>
      <div class="status-content display-flex">
        <div class="status-content__info">
          <span class="text-bold">Saturação</span>
          @if (hasVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData')) {
            <span>
              {{ getVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData') }}
            </span>
          }
          @if (!hasVitalValue(discriminatorTypeEnum.Saturacao, 'saturation', 'saturationComplementaryData')) {
            <mat-icon style="align-self: anchor-center;">cached</mat-icon>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Glicemia</span>
          @if (hasVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData')) {
            <span>
              {{ getVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData') }}
            </span>
          }
          @if (!hasVitalValue(discriminatorTypeEnum.Glicemia, 'glucose', 'glucoseComplementaryData')) {
            <mat-icon style="align-self: anchor-center;">cached</mat-icon>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Pressão</span>
          @if (hasVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData')) {
            <span>
              {{ getVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData') }}
            </span>
          }
          @if (!hasVitalValue(discriminatorTypeEnum.PressaoArterial, 'bloodPressure', 'bloodPressureSystoleComplementaryData')) {
            <mat-icon style="align-self: anchor-center;">cached</mat-icon>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Temperatura</span>
          @if (hasVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData')) {
            <span>
              {{ getVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData') }}
            </span>
          }
          @if (!hasVitalValue(discriminatorTypeEnum.Temperatura, 'temperature', 'temperatureComplementaryData')) {
            <mat-icon style="align-self: anchor-center;">cached</mat-icon>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Pulso</span>
          @if (hasVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData')) {
            <span>
              {{ getVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData') }}
            </span>
          }
          @if (!hasVitalValue(discriminatorTypeEnum.FrequenciaCardiaca, 'heartRate', 'heartRateComplementaryData')) {
            <mat-icon style="align-self: anchor-center;">cached</mat-icon>
          }
        </div>
      </div>
      <div class="display-flex justify-between">
        <div class="pain-content" [ngStyle]="{'background-color': episodeData.painColorCode}">
          <span class="text-bold">Dor</span>
          <span>{{episodeData.pain ? episodeData.pain : '-'}}</span>
        </div>
      </div>

    </div>
  </cdk-accordion-item>
</cdk-accordion>